// MainLayout.js
import PropTypes from "prop-types";

const MainLayout = ({ children }) => {
  return (
    <main className="min-h-screen overflow-x-hidden bg-white">
      {children}
    </main>
  );
};

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MainLayout;
